// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drag-n-drop-zone-default{height:100px;flex:1;display:flex;flex-direction:column;align-items:center;padding:20px;border-width:2;border-radius:2;border-color:#eee;border-style:dashed;background-color:#fafafa;color:#bdbdbd;outline:none;transition:border .24s ease-in-out;cursor:pointer}.drag-active{border-color:#2196f3}.drag-reject{border-color:#ff1744;background-color:#ffb2c1}.drag-accept{border-color:#00e676;background-color:#a9ffca}", ""]);
// Exports
module.exports = exports;
